import Diagnoses from './Diagnoses';

export default Diagnoses;
